module.exports = __webpack_public_path__ + "img/1-5.ff0a2542.svg";